// v-src-after-insert: sets an <img>'s src once it is inside its <picture> in the document.
// Vue sets an element's attributes before inserting it, and Safari starts downloading an
// <img src> straight away, before the <picture>'s <source>s apply: every hero downloaded
// its full-size fallback as well as the AVIF it showed. The URL is the directive's value,
// or a data-src attribute (which the build resolves like src, see vue.config.js).
const url = (el, binding) => binding.value || el.getAttribute('data-src');

export default {
  mounted(el, binding) {
    el.src = url(el, binding);
    el.removeAttribute('data-src');
  },
  updated(el, binding) {
    const next = url(el, binding);
    if (next && el.getAttribute('src') !== next) el.src = next;
  },
};
